import React, { useEffect } from "react";
import { useField } from "formik";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/de";
import { useTranslation } from "react-i18next";
import "./styles/common.scss";
import NumberFormat from "react-number-format";
import localizedFormat from "dayjs/plugin/localizedFormat";
import TextField from "@mui/material/TextField";

dayjs.extend(localizedFormat);

const InputField = ({
  label,
  name,
  onChange,
  type = "text",
  error,
  value,
  maxLength,
  docName,
  accept,
  dateFormatProp,
  ...rest
}) => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  dayjs.locale(language);
  const dateFormat = dateFormatProp || "DD MMMM YYYY";

  useEffect(() => {
    dayjs.locale(language);
  }, [language]);

  let inputElement;

  const dateValue = type === "date" && rest.value ? dayjs(rest.value) : null;

  if (type === "file") {
    inputElement = (
      <>
        <input
          type="text"
          value={docName}
          name={name}
          {...rest}
          maxLength={maxLength}
        />
        <input
          className="input-file"
          name={name}
          onChange={onChange}
          type="file"
          accept={accept}
          value={value}
        />
      </>
    );
  } else if (type === "textarea") {
    inputElement = (
      <textarea
        className="textarea"
        onChange={onChange}
        rows={5}
        name={name}
        value={value}
        {...rest}
      ></textarea>
    );
  } else if (type === "number") {
    inputElement = (
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          type="number"
          name={name}
          onChange={onChange}
          min={1}
          onInput={(e) => {
            e.target.value = e.target.value
              .toString()
              .replace(/^0+/, "")
              .replace(/[^\d]/g, "");
            const inputValue = parseInt(e.target.value);
            if (inputValue < 0) {
              e.target.value = 0;
            } else if (inputValue > 100) {
              e.target.value = 100;
            }
          }}
          value={value}
          {...rest}
        />

        <span
          style={{
            position: "absolute",
            top: error ? "49%" : "60%",
            left:
              name === "weight"
                ? value === 0
                  ? "20px"
                  : value
                  ? value < 10
                    ? "20px"
                    : value < 100
                    ? "30px"
                    : "37px"
                  : "10px"
                : value === 0
                ? "20px"
                : value
                ? value < 10
                  ? "20px"
                  : value < 100
                  ? "30px"
                  : "37px"
                : "30px",
            transform: "translateY(-50%)",
            color: value ? "black" : "gray",
          }}
        >
          {name === "weight" ? "g" : `%`}
        </span>
      </div>
    );
  } else if (type === "format-number") {
    inputElement = (
      <NumberFormat
        thousandSeparator="."
        decimalSeparator=","
        allowNegative={false}
        placeholder="00 € "
        suffix={name == "weight" ? " g" : " €"}
        onValueChange={(value) => {
          onChange(value?.floatValue);
        }}
        value={value}
        name={name}
        {...rest}
      />
    );
  } else if (type === "date") {
    inputElement = (
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={i18n?.language}
      >
        <DatePicker
          className="date-feild"
          value={value ? dayjs(value) : null}
          onChange={onChange}
          format={dateFormat}
          onKeyPress={(e) => e.preventDefault()}
          renderInput={(params) => (
            <TextField
              {...params}
              className="date-feild"
              type="text"
              value={dateValue}
              placeholder={dateFormat}
              onFocus={(e) => (e.target.type = "date")}
            />
          )}
        />
      </LocalizationProvider>
    );
  } else {
    inputElement = (
      <input
        onChange={onChange}
        value={value}
        type={type}
        name={name}
        {...rest}
      />
    );
  }

  return (
    <div className="custom-input">
      <label className="label">{label}</label>
      {type === "file" && <FileUploadOutlinedIcon className="upload-icon" />}
      {inputElement}
      {error !== undefined &&
        error !== null &&
        Object.keys(error).length > 0 && (
          <p
            style={{
              fontSize: "10px",
              color: "red",
              margin: 0,
            }}
          >
            {String(error[name])}
          </p>
        )}
    </div>
  );
};

export default InputField;
